/** 
 * @type {InvestorsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    name: null,
    ids: null,
    nationality_ids: null,
    country_of_residence_ids: null,
    genders: null,
    is_enabled: null,
}
/** 
* @returns {InvestorsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/InvestorsFilter.js